import _isEmpty from 'lodash/isEmpty';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Button } from 'grab-ui';
import I18n from 'i18n-js';
import InputField from 'components/v2/input-field/input-field';

import { FORM_FIELD_OPTIONS, FIELD_NAME } from 'views/v2/home/constants';
import { TABLE_COLUMN_V2 } from 'constants/bulk-upload-constants';

import css from './review-order-edit-modal.less';

const fieldKey = 'input';

class ReviewOrderEditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate(prevProps, _prevState) {
    const { originalValue: prevOriginalValue } = prevProps;
    const { originalValue, form: { setFieldsValue } } = this.props;
    if (prevOriginalValue !== originalValue) {
      setFieldsValue({
        [fieldKey]: originalValue,
      });
    }
  }

  onConfirmEdit = () => {
    const {
      onSaveEditCallback,
      form: { setFieldsValue, getFieldValue },
    } = this.props;
    const currentValue = getFieldValue(fieldKey);
    onSaveEditCallback(currentValue);
    // reset edit modal input
    setFieldsValue({
      [fieldKey]: null,
    });
  };

  onCancelEdit = () => {
    const { onCancelEditCallback, form: { setFieldsValue } } = this.props;
    // reset edit modal input
    setFieldsValue({
      [fieldKey]: null,
    });
    onCancelEditCallback();
  };

  render() {
    const { visible, editingFieldKey, form, originalValue } = this.props;
    let inputType = 'text';
    let fieldOptions = {
      initialValue: originalValue,
    };

    if (editingFieldKey === TABLE_COLUMN_V2.WEIGHT.key) {
      inputType = 'number';
      fieldOptions = {
        ...fieldOptions,
        ...FORM_FIELD_OPTIONS[FIELD_NAME.ITEM_WEIGHT],
      };
    }

    const fieldError = form.getFieldError(fieldKey);
    const disableConfirmBtn = !_isEmpty(fieldError); // allow empty value. e.g. remove unrequired field value

    return (
      <Modal
        centered
        visible={visible}
        title={I18n.t('bookingReview.editButton')}
        className={css.editOrderModal}
        maskClosable={false}
        footer={[
          <Button key="back" onClick={this.onCancelEdit}>
            {I18n.t('v2.commonButton.cancel')}
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={this.onConfirmEdit}
            disabled={disableConfirmBtn}
          >
            {I18n.t('v2.commonButton.confirm')}
          </Button>,
        ]}
      >
        <div className={css.editInput}>
          <InputField
            id={fieldKey}
            type={inputType}
            fieldOptions={fieldOptions}
            form={form}
          />
        </div>
      </Modal>
    );
  }
}

ReviewOrderEditModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  editingFieldKey: PropTypes.string,
  originalValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSaveEditCallback: PropTypes.func.isRequired,
  onCancelEditCallback: PropTypes.func.isRequired,
  form: PropTypes.shape({}).isRequired,
};

ReviewOrderEditModal.defaultProps = {
  editingFieldKey: '',
  originalValue: null,
};

export default Form.create()(ReviewOrderEditModal);
